import { FC } from 'react';
import { Battery } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

interface ContainerStatsProps {
  current50kw: number;
  max50kw: number;
  current100kw: number;
  max100kw: number;
}

export const ContainerStats: FC<ContainerStatsProps> = ({
  current50kw,
  max50kw,
  current100kw,
  max100kw,
}) => {
  const percentage50kw = (current50kw / max50kw) * 100;
  const percentage100kw = (current100kw / max100kw) * 100;

  return (
    <div className="space-y-3 pt-2">
      <div className="space-y-1">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2">
            <Battery className="h-4 w-4 text-muted-foreground" />
            <span className="font-medium">50kW Batterijen</span>
          </div>
          <span className="text-muted-foreground">
            {current50kw} / {max50kw}
          </span>
        </div>
        <Progress value={percentage50kw} className="h-2" />
      </div>

      <div className="space-y-1">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2">
            <Battery className="h-4 w-4 text-muted-foreground" />
            <span className="font-medium">100kW Batterijen</span>
          </div>
          <span className="text-muted-foreground">
            {current100kw} / {max100kw}
          </span>
        </div>
        <Progress value={percentage100kw} className="h-2" />
      </div>
    </div>
  );
};
